module.exports = __webpack_public_path__ + "images/rich_heading/other/artwork/icon_b88d1672c970cef37c380c95f7a0b988.png";